import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../assets/css/Zoomstyle.css';
import Button from 'react-bootstrap/Button';

const Zoomimage = ({ showModal, handleCloseModal, modalImage }) => {
  const [zoomStyle, setZoomStyle] = useState({});
  const [isZoomed, setIsZoomed] = useState(false);

  const handleMouseMove = (e) => {
    const container = e.currentTarget;
    const rect = container.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;

    setZoomStyle({
      transform: 'scale(2)',
      transformOrigin: `${xPercent}% ${yPercent}%`
    });
  };

  const handleMouseEnter = () => setIsZoomed(true);
  const handleMouseLeave = () => {
    setIsZoomed(false);
    setZoomStyle({});
  };

  return (
    <> 
     <Modal show={showModal} onHide={handleCloseModal} centered size="xl">
      <Modal.Header className='p-0 border-0 d-flex justify-content-end' >
      <Button
        onClick={handleCloseModal}
        aria-label="Close"
        style={{
          top: "10px",
          right: "10px",
          border: "1px solid rgb(146 141 141)",
          background: "#FFF",
          width: "31px",
          height: "31px",
          borderRadius: "20px",
          color: "#F00",
          cursor: "pointer",
          padding:"0"
        }}
      >
      <i className="bi bi-x-lg"></i>
      </Button> 

      </Modal.Header>
      <Modal.Body className="text-center" style={{ overflow: 'hidden' }}>
        <div
          className="zoom-container"
          onMouseMove={handleMouseMove}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <img
            src={modalImage}
            alt="Zoom"
            className={`zoom-image ${isZoomed ? 'zoomed' : ''}`}
            style={zoomStyle}
          />
        </div>
      </Modal.Body>
    </Modal>
    
    
    
    
    
    
    
    
    
    </>
  );
};
export default Zoomimage;
